import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuPortal,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Friend } from "types";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import toast from "react-hot-toast";
export const FriendState = ({ children, friend }: { children: React.ReactNode, friend: Friend }) => {

    const me = useQueryClient().getQueryData([
        "user"
    ]) as any;
    const [isOpen, setIsOpen] = useState(false);
    const changeStatus = async (status: string) => {
        const response = await fetch(`__SITE_BASE__/api/me/friends/${friend.users.filter((user) => user.id !== me!.user.id)[0].id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ status, id: friend.users.filter((user) => user.id !== me!.user.id)[0].id }),
        });
        const data = await response.json();
        if (data.success) {
            setIsOpen(false);

            toast.success(
                status === "accepted" ? `You accepted ${friend.users.filter((user) => user.id !== me!.user.id)[0].username}'s friend request` : `You rejected ${friend.users.filter((user) => user.id !== me!.user.id)[0].username}'s friend request`
            );
        } else {
            toast.error("An error occurred while processing your request");
        }
    }

    const cancel = async () => {
        const response = await fetch(`__SITE_BASE__/api/me/friends/null`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: friend.users.filter((user) => user.id !== me!.user.id)[0].id }),
        });
        const data = await response.json();
        if (data.success) {
            setIsOpen(false);
            toast.success(`You unfriended ${friend.users.filter((user) => user.id !== me!.user.id)[0].username}`);
        } else {
            toast.error("An error occurred while processing your request");
        }
    }

    return (
        <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
            <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
            <DropdownMenuPortal>
                <DropdownMenuContent className="w-56 bg-brand-darkest rounded-lg border-0 ml-28">
                    <DropdownMenuSeparator />
                    <DropdownMenuGroup className="mb-2 flex flex-col">

                        {friend?.status === "pending" && (
                            <div className="flex flex-col gap-2">
                                {friend.createdBy != me!.user.id ? (
                                    <>
                                        <button className="bg-brand-profile text-green-400 px-2 hover:bg-brand-default py-1 rounded-lg" onClick={() => {
                                            changeStatus("accepted");
                                        }}>Accept</button>
                                        <button className="bg-brand-profile hover:bg-brand-default text-red-400 px-2 py-1 rounded-lg" onClick={() => {
                                            changeStatus("rejected");
                                        }}>Decline</button>
                                    </>
                                ) : (
                                    <button className="text-red-400 px-2 rounded-lg py-1" onClick={() => {
                                        cancel();
                                    }}>Cancel</button>
                                )}
                            </div>
                        )}

                        {friend?.status === "accepted" && (
                            <button className="text-red-400 px-2 rounded-lg py-1" onClick={() => {
                                cancel();
                            }}>Unfriend</button>
                        )}

                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenuPortal>
        </DropdownMenu>
    );
};
